/**
 * 권한 API 실패·미시딩(pages 비어 있음) 시 프론트 폴백.
 * 서버 lib/permission-legacy.js · scripts/seed-permission.js 와 역할 허용 목록을 맞춘다.
 */
const { legacyStatusTransitionsForRole, STATUS_WILDCARD } = require('./statusTransition')

const ALL_ROLES = [
	'ADMIN',
	'SUB_ADMIN',
	'CS_ADMIN',
	'CS_SUB_ADMIN',
	'TECH_ADMIN',
	'TECH',
	'CS'
]

const except = (...ex) => ALL_ROLES.filter((r) => !ex.includes(r))

/** pageKey → 허용 역할. null 이면 전 역할 허용 (사이드바 레거시와 동일) */
const LEGACY_PAGE_ROLES = {
	home: null,
	'dashboard.analysis': null,
	admin: ['ADMIN', 'SUB_ADMIN'],
	client: null,
	project: null,
	'project.excelUpload': ['ADMIN', 'SUB_ADMIN'],
	analysis: null,
	settlement: null,
	profile: null,
	dashboard: null
}

/** ACTION feature_key → 허용 역할 */
const LEGACY_ACTION_ROLES = {
	'client.delete': ['ADMIN', 'SUB_ADMIN', 'CS_ADMIN', 'CS_SUB_ADMIN'],
	'project.delete': ['ADMIN', 'SUB_ADMIN', 'CS_ADMIN', 'CS_SUB_ADMIN'],
	'project.status.change': except('TECH'),
	'project.settlement.manage': ALL_ROLES,
	'project.report.manage': ALL_ROLES,
	'project.report.amend': ALL_ROLES,
	'project.result.review': ALL_ROLES,
	'analysis.deptFilter': ['ADMIN', 'SUB_ADMIN'],
	'analysis.journal.write': ['ADMIN', 'SUB_ADMIN', 'TECH_ADMIN', 'TECH'],
	'analysis.journal.download.all': except('TECH'),
	'settlement.manage': ALL_ROLES,
	'profile.editOthers': ['ADMIN'],
	'admin.account.manage': ['ADMIN', 'SUB_ADMIN'],
	'admin.revenue.read': ['ADMIN', 'SUB_ADMIN'],
	'admin.sampleCount.read': ['ADMIN', 'SUB_ADMIN'],
	'admin.projectImport.execute': ['ADMIN', 'SUB_ADMIN'],
	'admin.permission.manage': ['ADMIN', 'TECH_ADMIN'],
	'admin.matrix.manage': ['ADMIN', 'SUB_ADMIN'],
	'admin.department.manage': ['ADMIN', 'SUB_ADMIN'],
	'admin.projectTypeCode.manage': ['ADMIN', 'SUB_ADMIN'],
	'admin.report.manage': ALL_ROLES
}

/**
 * release ProjectStatus.vue projectStatusArr → statusTransition.LEGACY_TRANSITIONS 참조
 */

function roleAllowed(roles, role) {
	if (!role) return false
	if (roles == null) return true
	return roles.includes(role)
}

function legacyCanAccessPage(role, pageKey) {
	if (!pageKey) return true
	if (!(pageKey in LEGACY_PAGE_ROLES)) {
		// 알 수 없는 페이지: 사이드바처럼 제한 없으면 허용(잠금 방지)
		return true
	}
	return roleAllowed(LEGACY_PAGE_ROLES[pageKey], role)
}

function legacyCan(role, featureKey) {
	if (!featureKey) return false
	if (featureKey in LEGACY_PAGE_ROLES) return legacyCanAccessPage(role, featureKey)
	const roles = LEGACY_ACTION_ROLES[featureKey]
	if (!roles) return false
	return roleAllowed(roles, role)
}

function legacyCanTransitionStatus(role, from, to, event) {
	// 장애 폴백 경로에서는 관리자를 막지 않는다 (매트릭스를 못 읽는 상황이라
	// 좁히면 복구 조작 자체가 불가능해진다). 정상 경로는 매트릭스만 따른다.
	if (role === 'ADMIN' || role === 'SUB_ADMIN') return true
	const list = legacyStatusTransitionsForRole(role)
	if (event) return list.includes(`project.status:${from}>${to}:${event}`)
	const prefix = `project.status:${from}>${to}:`
	return list.some((k) => k.startsWith(prefix))
}

function legacyPermissionsPayload(role) {
	const pages = Object.keys(LEGACY_PAGE_ROLES).filter((k) => legacyCanAccessPage(role, k))
	const actions = Object.keys(LEGACY_ACTION_ROLES).filter((k) => legacyCan(role, k))
	// 관리자는 legacyCanTransitionStatus 가 전부 허용하므로, 드롭다운 목록도
	// 같은 뜻이 되도록 와일드카드로 돌려준다 (빈 목록이면 화면에 아무것도 안 뜬다)
	const statusTransitions = (role === 'ADMIN' || role === 'SUB_ADMIN')
		? [STATUS_WILDCARD]
		: legacyStatusTransitionsForRole(role)
	return { pages, actions, statusTransitions, degraded: true }
}

module.exports = {
	LEGACY_PAGE_ROLES,
	LEGACY_ACTION_ROLES,
	legacyCanAccessPage,
	legacyCan,
	legacyCanTransitionStatus,
	legacyStatusTransitionsForRole,
	legacyPermissionsPayload
}
